import { useState, useEffect } from 'react';
import { useSession } from "@clerk/clerk-react";
import * as sdk from 'fetchfox-sdk';

export const useApiKey = () => {
  const [apiKey, setApiKey] = useState();
  const clerkSession = useSession();

  useEffect(() => {
    if (clerkSession.isLoaded && clerkSession.session) {
      clerkSession.session.getToken()
        .then(async (token) => {
          const data = await sdk.call('POST', '/api/user/clerk', { token });
          console.log('Got API key via Clerk token:', data);
          setApiKey(data.apiKey);
        });
    }
  }, [clerkSession?.isLoaded, clerkSession.session]);

  return apiKey
}
